import { Button, Cell, Row, Alert } from '@dexma/ui-components';
import i18n from 'asset/translation';
import React, { FormEvent, ReactNode } from 'react';
import { ALERT_ACTION_TYPE } from 'adapter/in/common/context/Alert';
import { StyledAnimationDiv } from 'adapter/in/common/style';
import { StyledHeading, StyledHomeHeader, StyledInputSearchBar } from 'adapter/in/common/components/HomeList/style';

type HomeListProps = {
    addButtonProps: {
        setShowAddModal: (status: boolean) => void;
        displayAddButton: boolean;
        dataId: string;
    };
    alertProps: {
        alertMessage: string;
        alertType: ALERT_ACTION_TYPE;
        animationStyle: React.CSSProperties;
        showAlert: boolean;
    };
    headingTitle: string;
    handleSearchChange: (event: FormEvent<HTMLInputElement>) => void;
    children: ReactNode[];
};

const HomeList = (props: HomeListProps) => {
    const { addButtonProps, alertProps, headingTitle, handleSearchChange } = props;

    return (
        <>
            <StyledHomeHeader fluid data-testid='home-list' showAlert={alertProps.showAlert}>
                <StyledAnimationDiv animationStyle={alertProps.animationStyle}>
                    <Alert description={alertProps.alertMessage} type={alertProps.alertType} showIcon />
                    <Row className='heading'>
                        <Cell>
                            <StyledHeading text={headingTitle} type='h1'>
                                {addButtonProps.displayAddButton && (
                                    <Button
                                        data-testid='create-button'
                                        dataId={addButtonProps.dataId}
                                        variant='primary'
                                        iconBefore='add'
                                        isCircle
                                        onClick={() => {
                                            addButtonProps.setShowAddModal(true);
                                        }}
                                    />
                                )}
                            </StyledHeading>
                        </Cell>
                        <Cell xs={2}>
                            <StyledInputSearchBar
                                type='text'
                                placeholder={i18n.t('common.search')}
                                icon='search'
                                onChange={handleSearchChange}
                                data-testid='search-input'
                            />
                        </Cell>
                    </Row>
                    {...props.children}
                </StyledAnimationDiv>
            </StyledHomeHeader>
        </>
    );
};

export default HomeList;
